import React, {Component} from "react";
import PropTypes from "prop-types";
import {Typography, Upload, Icon, Row, Col} from "antd";

import {ReactComponent as UploadIcon} from "../assets/icons/upload-icon.svg";
import DownloadIcon from "icons/DownloadIcon";
import {displayGenericError} from "common/notifications";
import {FormattedMessage} from "react-intl";

import "./UploadWrapper.css";
import {generateUploadedFile} from "../api/api";

const {Text} = Typography;
const {Dragger} = Upload;

class UploadWrapperDisplay extends Component {
    handleDownload = (file) => {
        const {isOriginatorAttachedFile, isOrderFile} = this.props;
        generateUploadedFile(file.id, isOriginatorAttachedFile, isOrderFile)
            .then(response => {
                // const win = window.open(response.link, "_blank");
                // win.focus();
                console.log(response);


            })
            .catch(error => {
                displayGenericError(error);
            });
    };

    handleRemove = (file) => {
        // const {handleRemoveFile, file, type, index, itemId} = this.props;
        this.props.handleRemoveFile(file);
    };

    render() {
        const {title, style, files, disabled, children} = this.props;

        return (
            <div className="upload-wrapper" style={style}>
                <Row gutter={24}>
                    <Col md={24}>
                        <Text className="form-title">
                            {title} {children}
                        </Text>
                        <div style={{display: "flex", flexFlow: "row wrap"}}>
                            {files && files.length > 0 && (files.map(file => {
                                    return (
                                        <>
                                            <div style={{display: "inline-block", marginTop: 8}}>
                                                <div className="uploaded-wrapper-sm" style={{margin: 2}}>
                                                    <a style={{maxWidth: "150px", wordBreak: "break-all", color: "#0A9EB2", textOverflow: "ellipsis", overflow:"hidden",whiteSpace: "nowrap"}} className="uploaded-file-name" onClick={() => this.handleDownload(file)}>
                                                        {file.name}
                                                    </a>
                                                    <div className="uploaded-action-wrapper">
                                                        <div style={{marginTop: 3}}>
                                                            {!disabled && <Icon type="close" onClick={() => this.handleRemove(file)}/>}
                                                            {disabled && (
                                                                <Icon
                                                                    component={() => <DownloadIcon/>}
                                                                    onClick={() => this.handleDownload(file)}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <Text className="uploaded-file-size" style={{marginLeft: 2}}><FormattedMessage id="app.modal.uploadwrapper.filesize"/>{(!file.size || isNaN(file.size)) ? "" : Math.round(file.size) + "KB"}</Text>
                                            </div>
                                        </>
                                    )
                                })
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

UploadWrapperDisplay.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    style: PropTypes.object
};

export default UploadWrapperDisplay;
